import { Link } from "react-router-dom";
import { useLenis } from "lenis/react";
import { ArrowUpRight } from "lucide-react";
import { BRAND } from "@/lib/brand";
import { Logo } from "@/components/brand/Logo";

export const Footer = () => {
  const lenis = useLenis();
  const goTop = () => (lenis ? lenis.scrollTo(0) : window.scrollTo({ top: 0, behavior: "smooth" }));

  return (
    <footer data-testid="site-footer" className="relative bg-[#15171B] text-white overflow-hidden">
      <div className="grain" />
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-24 relative">
        <div className="grid gap-14 lg:grid-cols-[1.4fr_1fr]">
          <div>
            <Logo theme="dark" markClass="h-14 w-14" textClass="text-2xl" />
            <p className="mt-6 max-w-md text-2xl sm:text-3xl font-display font-medium leading-tight tracking-tight text-white/90">
              {BRAND.tagline}
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-10">
            <div>
              <p className="text-xs uppercase tracking-[0.2em] text-white/40">Contact</p>
              <ul className="mt-5 space-y-3">
                <li>
                  <a data-testid="footer-email-partnerships" href={`mailto:${BRAND.emails.partnerships}`} className="block break-words text-white/70 hover:text-white transition-colors duration-200 text-[15px]">
                    {BRAND.emails.partnerships}
                  </a>
                </li>
                <li>
                  <a data-testid="footer-email-general" href={`mailto:${BRAND.emails.general}`} className="block break-words text-white/70 hover:text-white transition-colors duration-200 text-[15px]">
                    {BRAND.emails.general}
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <p className="text-xs uppercase tracking-[0.2em] text-white/40">Company</p>
              <ul className="mt-5 space-y-3">
                <li>
                  <Link data-testid="footer-link-partner" to="/partner" onClick={goTop} className="group inline-flex items-center gap-1 text-white/70 hover:text-white transition-colors duration-200 text-[15px]">
                    For Education Providers <ArrowUpRight className="h-3.5 w-3.5" />
                  </Link>
                </li>
                <li>
                  <Link data-testid="footer-link-news" to="/news" onClick={goTop} className="group inline-flex items-center gap-1 text-white/70 hover:text-white transition-colors duration-200 text-[15px]">
                    News <ArrowUpRight className="h-3.5 w-3.5" />
                  </Link>
                </li>
                <li>
                  <Link data-testid="footer-link-privacy" to="/privacy" onClick={goTop} className="group inline-flex items-center gap-1 text-white/70 hover:text-white transition-colors duration-200 text-[15px]">
                    Privacy Policy <ArrowUpRight className="h-3.5 w-3.5" />
                  </Link>
                </li>
                <li>
                  <Link data-testid="footer-link-terms" to="/terms" onClick={goTop} className="group inline-flex items-center gap-1 text-white/70 hover:text-white transition-colors duration-200 text-[15px]">
                    Terms <ArrowUpRight className="h-3.5 w-3.5" />
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-20 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 border-t border-white/10 pt-8">
          <p className="text-sm text-white/40">© 2026 OpenDegree. All rights reserved.</p>
          <div className="flex items-center gap-2">
            <span className="h-2 w-2 rounded-full bg-cobalt animate-pulse-ring" />
            <span className="text-sm text-white/50">Coming Soon — building our UK education provider network</span>
          </div>
        </div>
      </div>
    </footer>
  );
};
